import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import {
  ClaimsService,
  ClaimWithCase,
} from 'src/app/core/services/claims.service';

@Component({
  selector: 'app-os-actions-lst',
  templateUrl: './os-actions-lst.component.html',
  styleUrls: ['./os-actions-lst.component.scss'],
})
export class OsActionsLstComponent implements OnInit {
  claim?: ClaimWithCase;

  @Output() multiClaims: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private cs: ClaimsService) {}

  async ngOnInit() {
    const claims = await this.cs.getMyClaimsWithCase(3, 0);

    if (claims?.length === 2) {
      this.multiClaims.emit(true);
    }
    console.log('claims', claims);
    this.claim = claims?.[0];
  }

  onSlideChange(event: any) {
    console.log('slide changed', event);
  }
}
